import image from "../../images/crm-liquidity.svg"

export default function CRMLiquidity() {
  return (
    <>
      <section className="bg-blue">
        <div className="px-5 2xl:px-0 md:grid grid-cols-2 gap-10 items-center py-10 lg:py-20 xl:max-w-6xl xl:mx-auto">
          <article>
            <h2 className="text-3xl lg:text-5xl mb-5 text-white lg:mb-10">
              Liquidity Providers
            </h2>
            <p className="text-white font-light">
              For almost a decade we've worked with a wide range of liquidity
              providers to ensure our clients can get the best rates. We offer
              you both market-leading providers, and a choice to integrate your
              preferred one, so you can use whatever suits you best.
            </p>
          </article>

          <article className="mt-10 md:mt-0">
            <img
              src={image}
              alt="Liquidity Providers"
              title="Liquidity Providers"
              className="block mx-auto"
            />
          </article>
        </div>
      </section>
    </>
  )
}
